<div class="p-field">
  <label for="broj-racuna" kodit-form-label>{{ brojLabel }}</label>
  <kodit-text-input
    formCtrlId="broj-racuna"
    [formCtrl]="brojCtrl"
    (onInputLeft)="inputLeft($event)"
  >
  </kodit-text-input>
</div>
